<template>
  <div
    v-bind:style="showModal ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-info" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">{{rq.doc_eir ? 'Editar':'Agregar'}} EIR</h5>
          <button
            @click="close(false)"
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="send()">
            <div class="form-group">
              <input placeholder="Número EIR" required type="text" class="form-control" v-model="rq.number_eir" />
            </div>
            <div class="form-group">
              <input required type="file" accept="image/*" class="form-control" v-on:change="onFileChange" />
            </div>
            <div class="form-group">
              <input type="submit" class="btn btn-primary" value="Enviar" />
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/helpers/api";
export default {
  props: ["id", "showModal", "rq"],
  data() {
    return {
      eir: "",
      doc_eir: null
    };
  },
  methods: {
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      const permitted_ext = ["image/png", "image/jpeg", "image/jpg"];
      if (!files.length || !permitted_ext.includes(files[0].type)) {
        this.showError("Formato de archivo inválido.");
      } else {
        this.doc_eir = files[0];
      }
    },
    showSuccess(label) {
      this.$toastr.success(label, "Operación exitosa", {
        positionClass: "toast-top-center",
        closeButton: true
      });
    },
    showError(label) {
      this.$toastr.error(label, "Error", {
        positionClass: "toast-top-center",
        closeButton: true
      });
    },
    send() {
      const formData = new FormData();
      formData.append("doc_eir", this.doc_eir);
      formData.append("requeriment_id", this.rq.id);
      formData.append("number_eir", this.rq.number_eir);
      api
        .post(`/eir`, formData)
        .then(response => {
          this.showSuccess("EIR agregado exitosamente.");
          this.close();
        })
        .catch(err => {
          this.showError("Error en la carga.");
        });
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>
